import React from "react";
import useAuth from "../hooks/useAuth";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { isPWA, isWebView } from "../utils/helpers";
import ROUTES from "../utils/routes";

export default function PwaAndAppAuthGuard(Component) {
  return function AuthenticatedComponent(props) {
    AuthenticatedComponent.propTypes = {
      children: PropTypes.node,
    };
    const { token } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);
    const link = urlSearchParams.get("link") || "";
    useEffect(() => {
      if (!link && token && (isWebView() || isPWA())) {
        navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
      }
    }, [token]);
    return <Component {...props} />;
  };
}
